import { FC } from "react";
import { Text } from "shared/components/Spor";
import { SuccessFill18Icon } from "shared/icons/SuccessFill18Icon";
import styled from "styled-components";

type IndicatorProps = {
  number: number;
  checked?: boolean;
};

const NumberIndicator = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.surfaceHover};
  color: ${({ theme }) => theme.colorTextMain};

  /* Using Stack leads to invalidDOMNesting (for DropsStepper), therefore I use a span styled as Stack */
  display: flex;
  justify-content: center;
`;

export const Indicator: FC<IndicatorProps> = ({ number, checked }) => {
  if (checked) return <SuccessFill18Icon />;
  return (
    <NumberIndicator>
      <Text
        as="span"
        style={{ fontSize: "12px", lineHeight: 0, alignSelf: "center" }}
      >
        {number}
      </Text>
    </NumberIndicator>
  );
};
